import React from "react";
import { Route, Routes } from "react-router-dom";

import MasterLayout from "@/layouts";
import TourManager from "@/pages/SuperUser/Administration/TourManager";
import ExcelSpreadsheet from "@/pages/ExcelEngine";
import ModuleOrderManager from "../../pages/ExcelEngine/ModuleOrderManager";

const ModuleGroupCreation = React.lazy(() =>
  import(
    "@/pages/SuperUser/GroupModules/ModuleGroupCreation/ModuleGroupCreation"
  )
);

const OwnerOverviewMindMap = React.lazy(() =>
  import("@/pages/SuperUser/OwnerAdministration/Overview")
);
const AddChartForm = React.lazy(() =>
  import("@/pages/SuperUser/Charts/ChartManagements/AddChartForm")
);
const EmailTemplateEditor = React.lazy(() =>
  import("@/pages/SuperUser/templates")
);

const Componentbuilder = React.lazy(() =>
  import("@/pages/ModuleBuilder/Componentbuilder")
);
const ModuleBuilderLayout = React.lazy(() => import("@/pages/ModuleBuilder"));
const ModuleLookup = React.lazy(() =>
  import("@/pages/ModuleBuilder/ModuleLookup")
);
const Benchmarks = React.lazy(() => import("@/pages/Benchmarks"));
const DataSyncHandler = React.lazy(() => import("@/pages/SuperUser/DataSync"));
const BenchmarksDetails = React.lazy(() =>
  import("@/pages/Benchmarks/BenchmarksDetails")
);

const UploadData = React.lazy(() =>
  import("@/pages/SuperUser/Administration/UploadData")
);

const ChartManagement = React.lazy(() =>
  import("@/pages/SuperUser/Charts/ChartManagements/Chartmanagement")
);
const EventManagement = React.lazy(() =>
  import("@/pages/SuperUser/Administration/EventManagement")
);

const ManageUser = React.lazy(() => import("@/pages/MangeUser"));

const ShipRegister = React.lazy(() => import("@/pages/SuperUser/ShipRegister"));
const SuperadminDashboard = React.lazy(() =>
  import("@/pages/SuperUser/SuperadminDashboard")
);
const ShipDetails = React.lazy(() =>
  import("@/pages/SuperUser/ShipRegister/ShipDetails")
);
const UserDataEntry = React.lazy(() =>
  import("@/pages/SuperUser/UserDataEntry")
);
const AccessDenied = React.lazy(() => import("../../routes/ErrorPage"));
const OwnerSettings = React.lazy(() =>
  import("@/pages/SuperUser/OwnerAdministration")
);
const Administration = React.lazy(() =>
  import("@/pages/SuperUser/Administration")
);

 
function Superoutes() {
  return (
    <MasterLayout>
      <Routes>
        <Route path="module-builder" element={<ModuleBuilderLayout />}>
          <Route path="" element={<ModuleLookup />} />
          <Route path=":name" element={<ModuleLookup />} />
          <Route
            path="module-forms/:module/:type"
            element={<Componentbuilder />}
          />
          <Route path="module-forms" element={<Componentbuilder />} />
          <Route path="module-forms/:module" element={<Componentbuilder />} />

          <Route path="userData/:tablename" element={<UserDataEntry />} />
        </Route>
        <Route path="ship-register" element={<ShipRegister />} />
        <Route path="owner-settings" element={<OwnerSettings />} />
        <Route path="chart-management" element={<ChartManagement />} />
        <Route path="chart-management/add" element={<AddChartForm />} />
        <Route
          path="chart-management/edit/:chartid"
          element={<AddChartForm />}
        />
        <Route path="email-templates" element={<EmailTemplateEditor />} />
        <Route path="event-management" element={<EventManagement />} />
        <Route path="admin-settings" element={<Administration />} />
        <Route path="upload-data" element={<UploadData />} />
        <Route path="tourmanager" element={<TourManager />} />

        <Route path="sync-data" element={<DataSyncHandler />} />
        <Route path="manage-users" element={<ManageUser />} />
        <Route path="manage-owner" element={<ManageUser />} />
        <Route path="customize-module" element={<ModuleGroupCreation />} />
        <Route path="customize-module/:id" element={<ModuleGroupCreation />} />

        <Route
          path="owner-overview/:ownerId"
          element={<OwnerOverviewMindMap />}
        />

        <Route path="userData/:tablename" element={<UserDataEntry />} />
        <Route path="/" element={<SuperadminDashboard />} />
        <Route path="shipdetails/:id" element={<ShipDetails />} />

        <Route path="benchmarks" element={<Benchmarks />} />

        <Route
          path="benchmarks/detailed/:id"
          element={<BenchmarksDetails type={"BENCHMARK"} />}
        />
        <Route
          path="excel"
          element={<ExcelSpreadsheet />}
        />

            <Route
          path="excelorder/:id"
          element={<ModuleOrderManager />}
        />



        <Route
          path="benchmarks/commondetail/:id"
          element={<BenchmarksDetails type={"COMMON"} />}
        />

        <Route
          path="/restricted-access"
          element={<AccessDenied code={"403"} />}
        />
      </Routes>
    </MasterLayout>
  );
}

export default Superoutes;
